import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import CustomerTable from '@/modules/supplier/components/CustomerTable';
import { UsersIcon } from '@heroicons/react/24/outline';

const CustomerList = () => {
  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();

  return (
    <>
      <SettingsHeader title="Customers" icon={<UsersIcon className="w-6 h-6" />} />

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <CustomerTable searchQuery={searchQuery} page={page} onChangePage={handlePageChange} />
    </>
  );
};

export default CustomerList;
